/**
 * SimpleEmitter to register callbacks for event types
 */
class SimpleEmitter {
  constructor() {
    /** @private */
    this._listeners = {};
  }
  /**
   * Register event handler for event type
   * @param {string} type - event type
   * @param {function} cb - callback function
   */
  on(type, cb) {
    const listeners = this._listeners;
    if (typeof cb !== 'function') {
      throw new TypeError('Listener must be a function');
    }
    if (!listeners[type]) {
      listeners[type] = [];
    }
    listeners[type].push(cb);
  }
  /**
   * Remove event handler
   * @param {string} [type] - event type. if empty, all events are removed
   * @param {function} [cb] - callback function, if empty, all events for given type are removed
   */
  off(type, cb) {
    if (!type && !cb) {
      this._listeners = {};
      return;
    }
    const listeners = this._listeners;
    if (!listeners[type]) return;
    if (!cb) {
      delete listeners[type];
      return;
    }
    listeners[type] = listeners[type].filter(stored => stored !== cb);
  }
  /**
   * Emit event including optional argument
   * @private
   * @param {string} type - event type
   * @param {any} [arg1] - argument
   * @returns
   */
  _emit(type, arg1) {
    const listeners = this._listeners;
    if (!listeners[type]) return;
    listeners[type].forEach(cb => {
      cb(arg1);
    });
  }
}

export default SimpleEmitter;
